import React from "react";
import { useState } from "react";
import { TextField, InputAdornment, IconButton, Autocomplete, Popper } from "@mui/material";
import { AutocompleteProps } from "@mui/material";

type StyledAutocompleteProps = {
    label: string;
    factor?: number;
    appTheme?: any;
    width?: number | string;
    placeholder?: string;
} & AutocompleteProps<any, any, any, any>;

export const StyledAutocompleteInput = ({label, factor, appTheme, width, placeholder, ...autocompleteProps }: StyledAutocompleteProps) => {

    factor = factor ? factor : 1;

    if (factor === undefined) {
        factor = 1;
    }
  
    return  (
        <Autocomplete
        {...autocompleteProps}
        sx={{
            '& .MuiAutocomplete-root': {
                '& .MuiAutocomplete-paper .MuiAutocomplete-option:focus': {
                    borderColor: appTheme.palette.primary.main, // Keep the border green when focused
                },
            },
            width: width ? width : '100%',
        }}
        clearOnBlur={false}
        onChange={(event: any, newValue: any) => {
            // Convert null to empty string on clear
            const valueToSet = newValue === null ? '' : newValue;
            if (autocompleteProps.onChange) {
                autocompleteProps.onChange(event, valueToSet, newValue === null ? 'clear' : 'selectOption');
            }
        }}
        renderInput={(params) => <TextField 
            {...params} 
            label={label} 
            variant="outlined" 
            placeholder={placeholder}
            error={!autocompleteProps.value === true}
            sx={{
                padding: 0,
                "& .MuiInputBase-input": { fontSize: 12 * (factor ? factor : 1), height: 12 * (factor ? factor : 1), padding: 1 },
                '& .MuiOutlinedInput-root': { 
                    padding: '5px 10px',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: appTheme.palette.primary.main, // Keep the border green when focused
                    },  
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: appTheme.palette.primary.main, // Always green outline
                    },
                },
                '& input': { textAlign: 'left', lineHeight: 'normal' },
              }}
            inputProps={{
                ...params.inputProps,
                inputMode: "text",
                autoComplete: "off",
                sx: {
                    fontSize: 12 * (factor ? factor : 1),
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: appTheme.palette.primary.main,
                    },
                },
            }}
            InputLabelProps={{
                sx: { fontSize: 14 * (factor ? factor : 1), lineHeight: 'normal', padding: '0px 10px', backgroundColor: 'white', marginTop: '0px' },
                shrink: true
            }}
            
        />}
        PopperComponent={(props) => (
            <Popper {...props} autoFocus sx={{ 
                zIndex: 1300, // Ensure it appears above other elements
                '& .MuiAutocomplete-listbox': {
                    maxHeight: 200,
                    overflowY: 'auto',
                    bgcolor: 'whitesmoke',
                },
                '& .MuiAutocomplete-option': {
                    padding: '5px 10px',
                    '&:hover': {
                        backgroundColor: `${appTheme.palette.primary.extraLight} !important`,
                        borderRadius: 3
                    },
                    fontSize: 12 * (factor ? factor : 1),
                },
                '& .Mui-focusVisible' : {
                        backgroundColor: `${appTheme.palette.primary.extraLight} !important`,
                        borderRadius: 3,
                },
                
            }} />
        )}
    />
    );
}